import { useEffect, useState } from "react";
import { apiError, cryptoApi } from "./api";
import type { RecordData } from "./api";

export function useResource<T>(path: string | null, params?: RecordData) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(Boolean(path));
  const [revision, setRevision] = useState(0);
  const key = JSON.stringify(params || {});
  useEffect(() => {
    const controller = new AbortController();
    setData(null);
    setError("");
    if (!path) { setLoading(false); return; }
    setLoading(true);
    cryptoApi.get<T>(path, JSON.parse(key), controller.signal).then(value => {
      if (!controller.signal.aborted) setData(value);
    }).catch(e => { if (!controller.signal.aborted) setError(apiError(e)); }).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [path, key, revision]);
  return { data, error, loading, reload: () => setRevision(v => v + 1) };
}
